import {API_DRIVER} from "../configs/axios";

export const TagsService = {
    fetchTagsAutocomplete: (integrationId, objectCategoryName, clientName, name) => {
        return API_DRIVER.get("/api/tags/autocomplete", {
            params: {
                integrationId: integrationId,
                objectCategoryName: objectCategoryName,
                clientName: clientName,
                name: name
            }
        })
    },
    insertTag: (body) => {
        return API_DRIVER.post(`/api/tags/insertTag`, body)
    },
    editTag: (integrationId, body) => {
        return API_DRIVER.patch(`/api/tags/editTag/customer/${integrationId}`, body)
    },
    deleteTag: (body) => {
        return API_DRIVER.post(`/api/tags/deleteTag`, body)
    },
    fetchTagsForSelectedItems: (body) => {
        return API_DRIVER.post(`/api/tags/getAssociationsForItems`, body)
    },
    updateAssociations: (body) => {
        return API_DRIVER.post('/api/tags/updateAssociations', body)
    },
    updateMultipleAssociations: (body) => {
        return API_DRIVER.post('/api/tags/updateMultipleAssociations', body)
    }
}
